import { connect } from 'react-redux';
import { deleteLabItem } from 'shared/store/actions/lab.values.actions';
import { LabValueDeleteComponent } from './lab-value-delete.component';

const mapStateToProps = ({ lang }) => ({
  lang: lang.DELETE_LAB_VALUE_CONFIRMATION,
});

export const LabValueDelete = connect(mapStateToProps, { deleteLabItem })(LabValueDeleteComponent);
